import(/* webpackMode: "eager" */ "/codebuild/output/src3361082059/src/doctor-dashboard/app/global-error.tsx");
